module.exports = __webpack_public_path__ + "resources/img/6@3x.d2e8372c.png";